/* 商品詳細：サイズ選択・価格切替・カート追加（/cart/add.js）・サイズ表モーダル・画廊（デザイン案 C） */
(function () {
  'use strict';
  var S = window.SNK;
  var cfgEl = document.getElementById('pdCfg');
  var form = document.getElementById('pdForm');
  if (!S || !cfgEl || !form) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (id) { return document.getElementById(id); };
  var radios = [].slice.call(form.querySelectorAll('input[type="radio"][name="id"]'));
  var single = form.querySelector('input[data-single]');
  var addBtn = $('add'), sbAdd = $('sbAdd'), errBox = $('pdErr');
  var QMIN = 1, QMAX = 1; /* 各サイズ 1 足まで */
  var busy = false;
  /* カートに入っているバリエーション ID（各サイズ 1 足までのため、同じサイズは再度追加しない） */
  var inCart = null, cartReq = null;
  function loadCart() {
    if (!cartReq) cartReq = S.refreshCart().then(function (c) {
      inCart = {};
      ((c && c.items) || []).forEach(function (it) { inCart[String(it.variant_id)] = true; });
      return inCart;
    });
    return cartReq;
  }
  function currentId() {
    var r = checked();
    return single ? single.value : (r && r.value);
  }
  var ADDED = 'カートに追加済み';
  function syncAdded() {
    if (!CFG.anyOk || busy) return;
    var id = currentId(), on = !!(id && inCart && inCart[String(id)]);
    [addBtn, sbAdd].forEach(function (b) {
      if (!b) return;
      var lbl = b.querySelector('[data-add-label]') || b;
      if (!b.getAttribute('data-default-label')) b.setAttribute('data-default-label', lbl.textContent);
      lbl.textContent = on ? ADDED : b.getAttribute('data-default-label');
      b.classList.toggle('is-added', on);
      b.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }

  form.noValidate = true;

  function yenCents(c) { return S.yen((Number(c) || 0) / 100); }
  function unit(label) { return CFG.multi ? label : label + 'cm'; }
  function checked() { return radios.filter(function (r) { return r.checked; })[0] || null; }

  /* ---------- サイズ選択 ---------- */
  function applyPick(r, fromUser) {
    if (!r || r.disabled) return;
    r.checked = true;
    var label = r.getAttribute('data-label'), price = yenCents(r.getAttribute('data-price'));
    $('selSize').textContent = unit(label);
    $('pdPrice').textContent = price;
    $('sbPrice').textContent = price;
    $('sbSize').textContent = unit(label);
    var av = $('avail');
    av.className = 'avail';
    av.innerHTML = '<b>' + S.esc(unit(label)) + '：お取り寄せ可能</b><br>ご注文後に買付・検品して発送いたします（お届け目安 7〜14日）。';
    hideErr();
    syncAdded();
    if (fromUser) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', r.value);
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) { /* noop */ }
    }
  }
  radios.forEach(function (r) {
    r.addEventListener('change', function () { applyPick(r, true); });
  });
  if (checked()) applyPick(checked(), false);

  /* ---------- 画廊 ---------- */
  var thumbs = $('thumbs'), mainImg = $('mainImg');
  if (thumbs && mainImg) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = b.getAttribute('data-src');
      thumbs.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  }

  /* ---------- サイズ・価格一覧モーダル ---------- */
  var chart = $('chart'), opener = $('openChart'), lastFocus = null;
  function modal(open) {
    if (!chart) return;
    chart.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { lastFocus = document.activeElement; $('closeChart').focus(); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (chart && opener) {
    opener.addEventListener('click', function () { modal(true); });
    $('closeChart').addEventListener('click', function () { modal(false); });
    chart.addEventListener('click', function (e) {
      if (e.target === chart) return modal(false);
      var tr = e.target.closest('tr[data-pick]');
      if (tr) pickFromChart(tr);
    });
    chart.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('tr[data-pick]')) {
        e.preventDefault(); pickFromChart(e.target);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && chart.classList.contains('open')) modal(false); });
  }
  function pickFromChart(tr) {
    var id = tr.getAttribute('data-pick');
    var r = radios.filter(function (x) { return x.value === id; })[0];
    if (r && !r.disabled) { applyPick(r, true); lastFocus = r; modal(false); }
  }

  /* ---------- 数量 ---------- */
  var qv = $('qv');
  function setQ(n) { n = Math.max(QMIN, Math.min(QMAX, parseInt(n, 10) || QMIN)); qv.value = n; return n; }
  if ($('qm')) $('qm').addEventListener('click', function () { setQ(Number(qv.value) - 1); });
  if ($('qp')) $('qp').addEventListener('click', function () { setQ(Number(qv.value) + 1); });
  qv.addEventListener('change', function () { setQ(qv.value); });

  /* ---------- カート追加 ---------- */
  function showErr(msg) { errBox.textContent = msg; errBox.hidden = false; }
  function hideErr() { errBox.hidden = true; errBox.textContent = ''; }
  function setBusy(on) {
    busy = on;
    [addBtn, sbAdd].forEach(function (b) {
      if (!b) return;
      b.disabled = on;
      var lbl = b.querySelector('[data-add-label]') || b;
      if (on) { b.setAttribute('data-prev', lbl.textContent); lbl.textContent = '追加中…'; }
      else if (b.getAttribute('data-prev')) { lbl.textContent = b.getAttribute('data-prev'); b.removeAttribute('data-prev'); }
    });
  }
  function submit(e) {
    if (e) e.preventDefault();
    if (busy || !CFG.anyOk) return;
    var r = checked();
    var id = single ? single.value : (r && r.value);
    if (!id) {
      S.toast(CFG.multi ? '種類を選択してください' : 'サイズを選択してください', true);
      showErr(CFG.multi ? '種類を選択してください。' : 'サイズを選択してください。');
      var sz = $('sz');
      if (sz) {
        sz.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = radios.filter(function (x) { return !x.disabled; })[0];
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 300);
      }
      return;
    }
    var qty = setQ(qv.value);
    hideErr();
    setBusy(true);
    loadCart().catch(function () { return null; }).then(function (ids) {
      if (ids && ids[String(id)]) {
        /* 同じサイズはすでにカートにある：追加しない（各サイズ 1 足まで） */
        setBusy(false);
        syncAdded();
        var m = 'このサイズはすでにカートに入っています（各サイズ1足までとなります）。';
        showErr(m);
        S.toast(m, true);
        return;
      }
      return S.addToCart(id, qty).then(function () {
        setBusy(false);
        if (inCart) inCart[String(id)] = true;
        syncAdded();
        S.miniCart({ title: CFG.title, variant: r ? unit(r.getAttribute('data-label')) : '', quantity: qty, image: CFG.image });
        cartReq = null;
        return loadCart();
      }).catch(function (err) {
        setBusy(false);
        var msg = (err && err.message) || 'カートに追加できませんでした。';
        showErr(msg);
        S.miniCart({ error: msg });
        cartReq = null;
        loadCart().then(syncAdded);
      });
    });
  }
  form.addEventListener('submit', submit);
  loadCart().then(syncAdded, function () { /* 取得失敗時は通常どおり */ });
  /* 戻る操作（bfcache）で表示された場合もカートの状態を取り直す */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { cartReq = null; loadCart().then(syncAdded); } });

  /* ---------- 他のカラー（同一モデルの別配色） ----------
     品番が「英数字-数字」（例 DD1391-100 / 1203A497-300）のときだけ、「-」前を基本品番として
     /search?view=colors（templates/search.colors.liquid）を取得。handle が「基本品番-」で始まる他商品を表示。
     /search/suggest.json は日本語ロケール非対応（417）のため使わない。失敗・該当なしは要素ごと削除（静かに非表示）。 */
  (function () {
    var box = $('otherColors');
    if (!box) return;
    var m = /^([A-Za-z0-9]+)-(\d+)$/.exec(box.getAttribute('data-code') || '');
    if (!m || !window.fetch || !window.JSON) { box.remove(); return; }
    var base = m[1], prefix = base.toLowerCase() + '-', self = String(CFG.handle || '').toLowerCase();
    var MAX = 12, started = false;

    function card(p) {
      var price = p.price ? S.esc(p.price) + (p.range ? '〜' : '') + '<span class="tax">税込</span>' : '―';
      return '<li><a href="' + S.esc(p.url.split('?')[0]) + '" title="' + S.esc(p.title || p.color) + '">' +
        '<span class="oc-ph">' + (p.image ? '<img src="' + S.esc(p.image) + '" alt="" loading="lazy" width="150" height="150">' : '<span class="noimg">画像なし</span>') + '</span>' +
        '<span class="oc-cl">' + S.esc(p.color) + '</span>' +
        '<span class="oc-pr">' + price + '</span>' +
        (p.ok ? '' : '<span class="oc-ng">お取り寄せ不可</span>') +
        '</a></li>';
    }
    function render(list) {
      if (!Array.isArray(list)) throw new Error('bad');
      var seen = {};
      var items = list.filter(function (p) {
        if (!p || typeof p.handle !== 'string' || typeof p.url !== 'string') return false;
        var h = p.handle.toLowerCase();
        if (h.indexOf(prefix) !== 0 || h === self || seen[h]) return false;
        seen[h] = true;
        return true;
      });
      /* お取り寄せ可能を先に（元の順序は維持） */
      items = items.filter(function (p) { return p.ok; }).concat(items.filter(function (p) { return !p.ok; })).slice(0, MAX);
      if (!items.length) { box.remove(); return; }
      box.setAttribute('aria-labelledby', 'ocTtl');
      box.innerHTML = '<h2 class="oc-ttl" id="ocTtl">他のカラー</h2><ul class="oc-list">' + items.map(card).join('') + '</ul>';
    }
    function load() {
      if (started) return;
      started = true;
      fetch(S.url('search?type=product&view=colors&q=' + encodeURIComponent(base)), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { render(JSON.parse(t)); })
        .catch(function () { box.remove(); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '300px 0px' });
      io.observe(box);
    } else if (document.readyState === 'complete') {
      setTimeout(load, 0);
    } else {
      window.addEventListener('load', load);
    }
  })();

  /* ---------- おすすめ（同じブランドの同じモデル、価格の近い順） ----------
     英語名の「"配色"」より前・コラボ名（×）より後ろの先頭 3 語（例 "Nike Dunk Low"）で商品検索し、
     templates/search.cards.liquid のカードから、同じブランド・価格 0.6〜1.6 倍・同一品番の別配色以外を価格の近い順に 10 件。
     3 語で 4 件未満なら先頭 2 語でも検索して補う。該当なし・失敗時はセクションごと非表示のまま。 */
  (function () {
    var sec = $('recSec'), grid = $('recGrid');
    if (!sec || !grid || !window.fetch) return;
    var vendor = sec.getAttribute('data-vendor') || '', price = Number(sec.getAttribute('data-price')) || 0;
    var self = String(CFG.handle || '').toLowerCase();
    var oc = $('otherColors'), m = /^([A-Za-z0-9]+)-/.exec((oc && oc.getAttribute('data-code')) || '');
    var sameModel = m ? m[1].toLowerCase() + '-' : null;
    var t = String(CFG.title || '').split('"')[0];
    if (t.indexOf('×') > -1) t = t.split('×').pop();
    var words = t.replace(/\([^)]*\)/g, ' ').split(/\s+/).filter(function (w) {
      return w && !/^(women'?s|men'?s|wmns|kids'?|gs|ps|td|big|little)$/i.test(w);
    });
    if (words.length < 2 || !price) return;
    var queries = [words.slice(0, 3).join(' ')];
    if (words.length > 2) queries.push(words.slice(0, 2).join(' '));
    var MAX = 10, seen = {}, picks = [], started = false;
    function fetchCards(q) {
      return fetch(S.url('search') + '?type=product&view=cards&options%5Bprefix%5D=last&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          [].slice.call(tpl.content.querySelectorAll('[data-h]')).forEach(function (el) {
            var h = String(el.getAttribute('data-h') || '').toLowerCase(), p = Number(el.getAttribute('data-p')) || 0;
            if (!h || seen[h] || h === self) return;
            seen[h] = true;
            if (sameModel && h.indexOf(sameModel) === 0) return;
            if (el.getAttribute('data-v') !== vendor || !p) return;
            var ratio = p / price;
            if (ratio < 0.6 || ratio > 1.6) return;
            var card = el.querySelector('.card');
            if (card) picks.push({ card: card, d: Math.abs(Math.log(ratio)), ok: el.getAttribute('data-ok') === '1' });
          });
        });
    }
    function show() {
      picks.sort(function (a, b) { return (b.ok - a.ok) || (a.d - b.d); });
      var list = picks.slice(0, MAX);
      if (!list.length) return;
      grid.innerHTML = '';
      list.forEach(function (x) { grid.appendChild(x.card); });
      S.syncFavButtons(grid);
      sec.hidden = false;
    }
    function load() {
      if (started) return;
      started = true;
      fetchCards(queries[0]).then(function () {
        if (picks.length < 4 && queries[1]) return fetchCards(queries[1]);
      }).then(show, show);
    }
    /* 画面下部にあるため、近づいたら取得（hidden 中は交差判定できないので直前に置いた高さ 0 の目印を監視） */
    var anchor = document.createElement('div');
    sec.parentNode.insertBefore(anchor, sec);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(anchor);
    } else {
      window.addEventListener('load', load);
    }
  })();

  /* お気に入りボタンの文言を現在の状態に合わせる */
  document.querySelectorAll('.buy [data-fav]').forEach(function (b) {
    var on = S.isFav(b.getAttribute('data-fav'));
    var lbl = b.querySelector('[data-fav-label]');
    if (lbl) lbl.textContent = on ? 'お気に入り済み' : 'お気に入り';
  });
})();
